import type { DynamicClient } from '../../client/types';
import { hydrateStateWithStorage } from './hydrateStateWithStorage';
import { syncStateWithStorage } from './syncStateWithStorage';

export const initializeStorageSync = async (client: DynamicClient) => {
  // Initialize the state value with what's stored in the storage
  await hydrateStateWithStorage(client);

  // Keep the storage up to date with the state
  syncStateWithStorage(client);
};
